module.exports = __webpack_public_path__ + "static/media/workoutt.27274a26.jpg";